// extracted by mini-css-extract-plugin
export default {"box":"AddressForm_box__o+vwW","country":"AddressForm_country__JsWJX","ltr":"AddressForm_ltr__8BeGN"};